import { observable } from "mobx";
import { Type } from "class-transformer";
import RegisteredChargeResponse from "./registeredChargeResponse";
import VehicleRegistrationResponse from "./vehicleRegistrationResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeRegistrationsResponse {
  @observable
  @Type(() => VehicleRegistrationResponse)
  vehicle!: VehicleRegistrationResponse;

  /**
   * Vehicle was given exemption from charges.
   */
  @observable
  isGivenExemption!: boolean;

  /**
   * Possible exemption reason IDs.
   */
  @observable
  possibleExemptionReasonIds!: string[];

  /**
   * Information about an existing valid charges.
   */
  @observable
  @Type(() => RegisteredChargeResponse)
  charges!: RegisteredChargeResponse[];
}
